import * as React from 'react';
import './RoadmapAdmin.css';
import { AppStore } from '../../stores';
import { inject, observer } from 'mobx-react';
import AdminService from '../../services/AdminService';
import { IUser } from '../../interfaces/IUser';
import User from '../users/user/User';
import LogoBar from '../logoBar/LogoBar';
import Header from '../header/Header';
import RoadmapService from '../../services/RoadmapService';
import Moment from 'react-moment';
import { IRoadmap } from '../../interfaces/IRoadmap';

export interface IProps {
  appStore?: AppStore;
}

export interface IState {
  userEmail?: string;
  selectedUser?: IUser;
  usersWithRoadmap?: IUser[];
}

@inject('appStore')
@observer
export default class RoadmapAdmin extends React.Component<IProps, IState> {

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  private filterUsers(): void {
    const usersWithRoadmap: IUser[] = [];
    AdminService.getUsers(this.state.userEmail).then((users: IUser[]) => {
      if (users && users.length > 0) {
        users.forEach((user: IUser) => {
          RoadmapService.getRoadmapForUser(user, this.props.appStore!.user.masterKey).then((roadmap: IRoadmap) => {
            if (roadmap?.answers && roadmap.answers.length > 0) {
              user.roadmap = roadmap;
              RoadmapService.getStatusSheets(user, this.props.appStore!.user.masterKey).then((statusSheets) => {
                user.statusSheets = statusSheets;
                usersWithRoadmap.push(user);
                this.setState({
                  usersWithRoadmap
                });
              });
            }
          });
        });
      }
    });
  }

  private renderSelectedRoadmap(): JSX.Element {
    return (
      <div className='roadmapForUser' >
        <h1 style={{ color: "#333333", fontSize: "25px" }}>{`Roadmap for ${this.state.selectedUser?.name}`}</h1>
        <div className="roadmapQuestion">
          <label>1) Dit formål (Min Nordstjerne)? Dit dybeste hvorfor. Det hvorfor der ligger nedenunder alle dine intentioner</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[1]}</div>
        </div>
        <h3>De værdier som skal vejlede dine handlinger i år</h3>
        <div className="roadmapQuestion">
          <label>2) Stretch value</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[2]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>3) Stretch value</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[3]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>4) Stretch value</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[4]}</div>
        </div>
        <h3>Dine ord for i år</h3>
        <div className="roadmapQuestion">
          <label>5) Dit styrkende mantra for i år</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[5]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>6) Dine styrkende ord for i år</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[6]}</div>
        </div>
        <h2>Vælg Den Magiske Rækkefølge på dine 3 livsområder fra dit Stressbarometer (husk Domino-effekten med lettest først)</h2>
        <h3>1. Livsområde</h3>
        <div className="roadmapQuestion">
          <label>7) 1. Livsområde Det livsområde du har valgt at fokusere på, som det vigtigste i år</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[7]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>8) 1. Livsområde: Drøm Hvad er din drøm indenfor dit første livsområde?</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[8]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>9) 1. Livsområde: Mål om 5 år Hvad er dit mål om 5 år indenfor dit første livsområde?</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[9]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>10) 1. Livsområde: Mål om 1 år (Kun ét) Hvad er dit mål om 1 år indenfor dit første livsområde?</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[10]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>11) Delmål (indenfor 1. livsområde) Om 11 måneder</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[11]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>12) Delmål (indenfor 1. livsområde) Om 10 måneder</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[12]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>13) Delmål (indenfor 1. livsområde) Om 9 måneder</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[13]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>14) Delmål (indenfor 1. livsområde) Om 8 måneder</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[14]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>15) Delmål (indenfor 1. livsområde) Om 7 måneder</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[15]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>16) Delmål (indenfor 1. livsområde) Om 6 måneder</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[16]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>17) Delmål (indenfor 1. livsområde) Om 5 måneder</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[17]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>18) Delmål (indenfor 1. livsområde) Om 4 måneder</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[18]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>19) Delmål (indenfor 1. livsområde) Om 3 måneder</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[19]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>20) Delmål (indenfor 1. livsområde) Om 2 måneder</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[20]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>21) Delmål (indenfor 1. livsområde) Om 1 måned</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[21]}</div>
        </div>
        <h3>2. Livsområde</h3>
        <div className="roadmapQuestion">
          <label>22) 2. Livsområde Det livsområde du har valgt at fokusere på, som det næst vigtigste i år.</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[22]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>23) 2. Livsområde: Drøm Hvad er din drøm indenfor dit andet livsområde?</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[23]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>24) 2. Livsområde: Mål om 5 år Hvad er dit mål om 5 år indenfor dit andet livsområde?</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[24]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>25) 2. Livsområde: Mål om 1 år (Kun ét) Hvad er dit mål om 1 år indenfor dit andet livsområde?</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[25]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>26) Delmål (indenfor 2. livsområde) Om 11 måneder</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[26]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>27) Delmål (indenfor 2. livsområde) Om 10 måneder</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[27]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>28) Delmål (indenfor 2. livsområde) Om 9 måneder</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[28]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>29) Delmål (indenfor 2. livsområde) Om 8 måneder</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[29]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>30) Delmål (indenfor 2. livsområde) Om 7 måneder</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[30]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>31) Delmål (indenfor 2. livsområde) Om 6 måneder</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[31]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>32) Delmål (indenfor 2. livsområde) Om 5 måneder</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[32]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>33) Delmål (indenfor 2. livsområde) Om 4 måneder</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[33]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>34) Delmål (indenfor 2. livsområde) Om 3 måneder</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[34]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>35) Delmål (indenfor 2. livsområde) Om 2 måneder</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[35]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>36) Delmål (indenfor 2. livsområde) Om 1 måned</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[36]}</div>
        </div>
        <h3>3. Livsområde</h3>
        <div className="roadmapQuestion">
          <label>37) 3. Livsområde Det livsområde du har valgt at fokusere på, som det tredje vigtigste i år.</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[37]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>38) 3. Livsområde: Drøm Hvad er din drøm indenfor dit tredje livsområde.</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[38]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>39) 3. Livsområde: Mål om 5 år Hvad er dit mål om 5 år indenfor dit tredje livsområde?</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[39]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>40) 3. Livsområde: Mål om 1 år (Kun ét) Hvad er dit mål om 1 år indenfor dit tredje livsområde?</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[40]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>41) Delmål (indenfor 3. livsområde) Om 11 måneder</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[41]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>42) Delmål (indenfor 3. livsområde) Om 10 måneder</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[42]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>43) Delmål (indenfor 3. livsområde) Om 9 måneder</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[43]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>44) Delmål (indenfor 3. livsområde) Om 8 måneder</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[44]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>45) Delmål (indenfor 3. livsområde) Om 7 måneder</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[45]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>46) Delmål (indenfor 3. livsområde) Om 6 måneder</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[46]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>47) Delmål (indenfor 3. livsområde) Om 5 måneder</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[47]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>48) Delmål (indenfor 3. livsområde) Om 4 måneder</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[48]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>49) Delmål (indenfor 3. livsområde) Om 3 måneder</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[49]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>50) Delmål (indenfor 3. livsområde) Om 2 måneder</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[50]}</div>
        </div>
        <div className="roadmapQuestion">
          <label>51) Delmål (indenfor 3. livsområde) Om 1 måned</label>
          <div className="roadmapAnswer">{this.state.selectedUser?.roadmap?.answers[51]}</div>
        </div>
      </div>
    );
  }

  private renderStatusSheetsForSelectedUser(): JSX.Element {
    return (
      <div className='statusSheetsForUser'>
        <h2>Status Sheets for {this.state.selectedUser?.name}</h2>
        {this.state.selectedUser?.statusSheets && this.state.selectedUser.statusSheets.length > 0 ?
          this.state.selectedUser.statusSheets.map((statusSheet, index) => {
            return (
              <div
                key={index}
                className="statusSheetItem"
                onClick={() => {
                  statusSheet = statusSheet;
                }}
              >
                <h3>{window.loc.strings.weeklyStatusSheet}</h3>
                <div className="roadmapQuestion">
                  <label>Ugenummer*</label>
                  <div className="roadmapWeekNumber">{statusSheet?.weekNumber}</div>
                </div>
                <div className="roadmapQuestion">
                  <label>Hvor mange timer har du investeret i dine drømme denne uge?*</label>
                  <div className="roadmapAnswer">{statusSheet?.answers?.[0]}</div>
                </div>
                <div className="roadmapQuestion">
                  <label>Hvad har du opnået i denne uge?*</label>
                  <div className="roadmapAnswer">{statusSheet?.answers?.[1]}</div>
                </div>
                <div className="roadmapQuestion">
                  <label>Hvor meget har du faktureret for i denne uge?*</label>
                  <div className="roadmapAnswer">{statusSheet?.answers?.[2]}</div>
                </div>
                <div className="roadmapQuestion">
                  <label>Din største succes i denne uge*</label>
                  <div className="roadmapQuestionNote">Hvad er du mest stolt af, at du har opnået?</div>
                  <div className="roadmapQuestionNote">OBS: Dette deles i Slack tråden med resten af dit hold automatisk.</div>
                  <div className="roadmapAnswer">{statusSheet?.answers?.[3]}</div>
                </div>
                <div className="roadmapQuestion">
                  <label> Profilbillede*</label>
                  <div className="roadmapQuestionNote">Tag et billede af dig selv hver uge og upload her</div>
                  <img
                    src={statusSheet?.imageUrl}
                    alt="Profilbillede"
                    style={{
                      width: "300px",
                      height: "300px",
                      objectFit: "cover",
                      marginTop: "10px"
                    }}
                  />
                </div>
              </div>
            );
          })
          :
          <div>Der er endnu ingen Stutus Sheets for denne bruger</div>
        }
      </div>
    );
  }

  render() {
    let top = this.props.appStore?.isMobile && window.platform !== "ios" ? 0 : 50;
    let height = this.props.appStore?.isMobile ? `calc(100% - ${this.props.appStore?.isMobile && window.platform !== "ios" ? 80 : 130}px)` : (this.props.appStore?.podcastToPlay ? `calc(100% - ${this.props.appStore?.isMobile && window.platform !== "ios" ? 101 : 151}px)` : `calc(100% - ${this.props.appStore?.isMobile && window.platform !== "ios" ? 0 : 50}px)`);
    if (this.props.appStore?.isIpad) {
      height = this.props.appStore?.podcastToPlay ? `calc(100% - 201px)` : `calc(100% - 100px)`;
      top = 100;
    }
    return (
      <div
        className="adminRoadmaps"
        style={{
          left: this.props.appStore!.isMobile ? 0 : 250,
          width: this.props.appStore!.isMobile ? "100vw" : "calc(100vw - 250px)",
          top: top,
          height: height
        }}
      >
        {location.href.indexOf("mindPaperId") == -1 && this.props.appStore!.user && this.props.appStore!.isMobile && !window.location.pathname.includes("/enneagrammy") &&
          <LogoBar />
        }
        <Header
          headline={"Roadmaps"}
        />
        <div className="container">
          <div
            className="filter"
            style={{
              height: "100px",
              maxWidth: "600px",
            }}
          >
            <div className="inputFieldLabel">Brugere</div>
            <input
              type="text"
              placeholder="Søg efter brugere (email)"
              value={undefined}
              onChange={(event: any) => {
                this.setState({ userEmail: event.target.value.toLowerCase() });
              }}
            />
            <div
              className="searchButton"
              onClick={() => this.filterUsers()}
            />
          </div>
          <div className='roadmapsContainer'>
            {this.state.usersWithRoadmap?.map((user: IUser) => {
              return (
                <div
                  key={user?.id}
                  className="roadmapItem"
                  style={{
                    border: this.state.selectedUser?.id === user.id ? "1px solid #ffffff" : "1px solid transparent",
                  }}
                  onClick={() => {
                    this.setState({
                      selectedUser: user
                    });
                  }}
                >
                  <span>{user?.name}</span>
                  <Moment fromNow >{user?.roadmap?.updatedAt}</Moment>
                </div>
              )
            })}
          </div>
          {this.state.selectedUser &&
            <>
              {this.state.selectedUser?.roadmap ?
                <>
                  <div className='selectedRoadmap'>
                    {this.renderSelectedRoadmap()}
                  </div>
                  <div className='statusSheets'>
                    {this.renderStatusSheetsForSelectedUser()}
                  </div>
                </>
                :
                <div
                  className='selectedRoadmap'
                  style={{
                    fontStyle: "italic",
                    color: "#777777"
                  }}>
                  Vælg en bruger for at se deres roadmap.
                </div>
              }
            </>
          }
        </div>
      </div>
    );
  }
}